import * as types from './types';

const initialState = {
  attachments: [],
  syncStatus: null,
  loading: false,
  error: null,
  total: 0,
};

const policyAttachmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Fetch Attachments ───────────────────────────────────────

    case types.FETCH_ATTACHMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        attachments: action.payload.results || action.payload,
        total: action.payload.count || action.payload.length,
      };

    case types.FETCH_ATTACHMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Create Attachment ───────────────────────────────────────

    case types.CREATE_ATTACHMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.CREATE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        attachments: [action.payload, ...state.attachments],
        total: state.total + 1,
      };

    case types.CREATE_ATTACHMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Bulk Attach ─────────────────────────────────────────────

    case types.BULK_ATTACH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.BULK_ATTACH_SUCCESS:
      return {
        ...state,
        loading: false,
        // Refresh attachments list after bulk attach
      };

    case types.BULK_ATTACH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Detach Policy ───────────────────────────────────────────

    case types.DETACH_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DETACH_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        attachments: state.attachments.filter((a) => a.id !== action.payload),
        total: state.total - 1,
      };

    case types.DETACH_POLICY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Update Attachment ───────────────────────────────────────

    case types.UPDATE_ATTACHMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.UPDATE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        attachments: state.attachments.map((a) =>
          a.id === action.payload.id ? action.payload : a
        ),
      };

    case types.UPDATE_ATTACHMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Sync Status ─────────────────────────────────────────────

    case types.FETCH_SYNC_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_SYNC_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        syncStatus: action.payload,
      };

    case types.FETCH_SYNC_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.TRIGGER_SYNC_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.TRIGGER_SYNC_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.TRIGGER_SYNC_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ── Utilities ───────────────────────────────────────────────

    case types.CLEAR_ATTACHMENT_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default policyAttachmentsReducer;
